import {Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'tdo-multi-dropdown',
  templateUrl: './tdo-multi-dropdown.component.html',
  styleUrls: ['./tdo-multi-dropdown.component.scss']
})
export class TdoMultiDropdownComponent implements OnInit, OnChanges {
  @Input() dataset: any[];
  @Input() selected: any[] = [];
  @Input() displayKey: string;
  @Input() isMultipleCaseItem: boolean = false;
  @Input() displayKeyByCase: string;
  @Input() isDisabled: boolean = false;

  @Input() width: string = '100px';
  @Input() height = 20;

  label = 'Select';
  isMenuOpen = false;

  @Output() selectedItems = new EventEmitter<any[]>();

  constructor() { }

  ngOnInit(): void {
      this.width = '100%';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selected) {
      this.setPersistence();
    }
  }

  validateEnable(){
    if(!this.isDisabled){
      this.isMenuOpen = !this.isMenuOpen;
    }
    else{
    this.isMenuOpen = false}
  }

  setPersistence() {
    if (!this.selected) {
      this.selected = [];
    } else {
      this.selected = this.selected.concat();
    }
  }

  toggle(cb: MatCheckbox, item: any) {
    cb.checked = !cb.checked;
    if (cb.checked) {
      if (this.selected && !this.selected.includes(item)) {
        this.selected.push(item);
      }
    } else {
      if (this.selected && this.selected.includes(item)) {
        const idx = this.selected.findIndex(p => p === item);
        if (idx > -1) {
          this.selected.splice(idx, 1);
        }
      }
    }
  }

  isChecked(item: any) {
    if (this.selected) {
      const keys = this.selected.map(p => p[this.displayKey]);
      return keys.includes(item[this.displayKey]);
    }

    return false;
  }

  clickOutside() {
    if (!this.isMenuOpen) {
      return;
    }
    this.isMenuOpen = false;
    if (this.selected) {
      this.selectedItems.emit(this.selected);
    }
  }

  getLabel() {
    if (this.selected && this.selected.length > 0) {
      let str = '';
      let i = 0;
      for (const item of this.selected) {
        i++;
        str += item[this.displayKey];
        if (i > 0 && i < this.selected.length) {
          str += ', ';
        }
      }
      return str;
    }

    return this.label;
  }
}
